import { TaskBoard } from '../components/TaskBoard';

export function Tasks() {
  return <TaskBoard />;
}

